<template>
  <bim-row id="service-video" class="services-lending__service-video mt-12 pt-6 mb-12 pb-8" justify="center">
    <bim-col class="services-lending__info-title mx-auto" cols="12" sm="8">Сервис мониторинга проектных потребностей</bim-col>
    <bim-col cols="12">
      <vue-plyr v-metric="'LENDING-SMPP_CLICK-ON-VIDEO'" class="lazy-load-on service-video mx-auto mb-11">
        <div data-plyr-provider="youtube" data-plyr-embed-id="gRvAXNkH50Y"></div>
      </vue-plyr>
    </bim-col>
    <bim-button @click="$emit('showModal')" v-metric="'LENDING-SMPP_CLICK-ON-SEND-REQUEST'" size="l"  class="get-access__button mx-auto" label="Получить доступ"></bim-button>
  </bim-row>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'
import bimButton from '@bimlib/components/bimButton'

export default {
  name: "block-showing",
  components: {
    bimCol,
    bimRow
  }
}
</script>